import api from './api';
import { Log } from '../types';

// Lấy tất cả logs
const getAll = () => {
  return api.get('/logs');
};

// Tìm kiếm logs
const search = (params: any) => {
  return api.get('/logs/search', { params });
};

// Thêm log mới
const create = (log: Omit<Log, 'id'>) => {
  return api.post('/logs', log);
};

// Xóa log
const remove = (id: number) => {
  return api.delete(`/logs/${id}`);
};

// Export các functions
const LogService = {
  getAll,
  search,
  create,
  remove
};

export default LogService; 